var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6123 5.38816L10.6123 5.38818C10.7295 5.50533 10.7295 5.69526 10.6123 5.81241L10.6123 5.81242L5.57802 10.8467L4.72447 11.7003H5.93158H20.0002C20.1658 11.7003 20.3002 11.8346 20.3002 12.0003C20.3002 12.166 20.1658 12.3003 20.0002 12.3003H5.93158H4.72446L5.57802 13.1539L10.6123 18.1881C10.6123 18.1881 10.6123 18.1881 10.6123 18.1881C10.7295 18.3053 10.7295 18.4953 10.6123 18.6125C10.4951 18.7296 10.3052 18.7296 10.188 18.6124L3.78807 12.2124L3.78806 12.2124C3.67091 12.0953 3.67091 11.9053 3.78806 11.7882L3.78807 11.7882L10.1881 5.38817L10.1881 5.38816C10.3052 5.271 10.4952 5.271 10.6123 5.38816Z",
    fill: "#09090B",
    stroke: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.79510021699cb7163698bb07d9a871cb.svg";
export { ForwardRef as ReactComponent };